<template>
  <Modal title="编辑作品信息" v-model="visible">
    <Form ref="userVideoForm" class="form" :model="userVideoParams" :rules="userVideoRules" :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item>
            学生：{{userVideoParams.uid}}-{{userVideoParams.nickname}}
          </Form-item>
        </Col>
        <Col :span="22">
          <Form-item label="作品名称" prop="title">
            <Input v-model="userVideoParams.title"/>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="分组" prop="ageGroup">
            <Select v-model.number="userVideoParams.ageGroup">
              <Option v-for="item in $constant.userVideoType" :key="item.code" :value="item.code">
                {{item.text}}
              </Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="学生作品" prop="videoUrl">
            <el-upload
              ref="videoUpload"
              class="upload-demo"
              :action="$appConfig.baseUrl + '/upload/fileUpload'"
              :on-change="videoChange"
              :on-success="videoSuccess"
              :on-error="handleUploadError"
              :on-exceed="videoExceed"
              :headers="headers"
              :on-progress="handleProgress"
              :before-upload="beforeUpload"
              :disabled="!formReady"
              accept="video/*"
              :limit="1"
              :file-list="videoFileList">
              <el-button size="small" :disabled="!formReady"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
            </el-upload>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="作品封面" prop="videoPicUrl">
            <el-upload
              ref="videoPicUpload"
              class="upload-demo"
              :action="$appConfig.baseUrl + '/upload/fileUpload'"
              :on-change="videoPicChange"
              :on-success="videoPicSuccess"
              :on-error="handleUploadError"
              :on-exceed="videoPicExceed"
              :headers="headers"
              :on-progress="handleProgress"
              :before-upload="beforeUpload"
              :disabled="!formReady"
              accept="image/*"
              :limit="1"
              :file-list="videoPicFileList">
              <el-button size="small" :disabled="!formReady"><i class="el-icon-upload el-icon--left"></i>上传</el-button>
            </el-upload>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="抖音链接" prop="douyinUrl">
            <Input v-model="userVideoParams.douyinUrl" placeholder="抖音分享链接或文案">
              <Button slot="append" size="small" :disabled="!(userVideoParams.douyinUrl || '').trim() || loadingFetch" @click="fetchShortVideo('douyin')">抓取</Button>
            </Input>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="小红书链接" prop="xhsUrl">
            <Input v-model="userVideoParams.xhsUrl" placeholder="小红书分享链接或文案">
              <Button slot="append" size="small" :disabled="!(userVideoParams.xhsUrl || '').trim() || loadingFetch" @click="fetchShortVideo('xhs')">抓取</Button>
            </Input>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
          <Form-item label="视频号链接" prop="channelsUrl">
            <Input v-model="userVideoParams.channelsUrl" placeholder="视频号分享链接或文案">
              <Button slot="append" size="small" :disabled="!(userVideoParams.channelsUrl || '').trim() || loadingFetch" @click="fetchShortVideo('channels')">抓取</Button>
            </Input>
          </Form-item>
        </Col>
      </Row>
      <Row v-if="userVideoParams.svSyncStatus != null">
        <Col :span="22">
          <Form-item label="同步状态">
            <span>{{ syncStatusText }}</span>
            <span v-if="userVideoParams.svAuthor" style="margin-left:12px">作者：{{userVideoParams.svAuthor}}</span>
            <span style="margin-left:12px">合计 赞{{userVideoParams.svLikeCount||0}} / 藏{{userVideoParams.svCollectCount||0}} / 评{{userVideoParams.svCommentCount||0}}</span>
          </Form-item>
        </Col>
      </Row>
      <Row v-if="svTasks.length">
        <Col :span="22">
          <Form-item label="平台抓取">
            <div v-for="task in svTasks" :key="task.platform">
              <span>{{ platformText(task.platform) }}：{{ taskStatusText(task.status) }}</span>
              <span v-if="task.author" style="margin-left:12px">作者：{{task.author}}</span>
              <viewer v-if="task.coverUrl" style="display:inline-block;margin-left:12px;vertical-align:middle">
                <img :src="mediaUrl(task.coverUrl)" alt="封面" style="width:28px;height:28px;object-fit:cover;cursor:pointer;vertical-align:middle">
              </viewer>
              <span style="margin-left:12px">赞{{task.likeCount||0}} / 藏{{task.collectCount||0}} / 评{{task.commentCount||0}}</span>
              <span v-if="task.status === 'fail' && task.errorMsg" style="margin-left:12px;color:#ed4014">失败原因：{{task.errorMsg}}</span>
            </div>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="warning" size="large" :loading="loadingFetch" @click="fetchShortVideo()">全部抓取</Button>
      <Button type="primary" size="large" :loading="loadingEditModal" :disabled="!formReady" @click="editUserVideo">提交</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: 'EditUserVideoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      },
      itemId: Number
    },
    data () {
      return {
        visible: this.value,
        userVideoParams: {
          uid: null,
          title: '',
          videoUrl: '',
          videoPicUrl: '',
          douyinUrl: '',
          xhsUrl: '',
          channelsUrl: '',
          svSyncStatus: null,
          svAuthor: '',
          svLikeCount: 0,
          svCollectCount: 0,
          svCommentCount: 0,
          ageGroup: null,
          nickname: ''
        },
        svTasks: [],
        loadingFetch: false,
        userVideoRules: {
          title: [
            { type: 'string', required: true, message: '请填写作品名称', trigger: 'blur' }
          ],
          uid: [
            { type: 'integer', required: true, message: '请填写学生ID', trigger: 'blur' }
          ],
          ageGroup: [
            { type: 'integer', required: true, message: '请选择类型', trigger: 'blur' }
          ]
        },
        headers: {},
        videoFileList: [],
        videoPicFileList: [],
        videoUrl: '',
        videoPicUrl: '',
        loadingEditModal: false,
        formReady: false,
        localVideoDirty: false,
        localPicDirty: false
      }
    },
    computed: {
      syncStatusText () {
        let s = this.userVideoParams.svSyncStatus
        let map = { 0: '无', 1: '抓取中', 2: '成功', 3: '失败' }
        return map[s] != null ? map[s] : '-'
      }
    },
    methods: {
      blankParams () {
        return {
          uid: null,
          title: '',
          videoUrl: '',
          videoPicUrl: '',
          douyinUrl: '',
          xhsUrl: '',
          channelsUrl: '',
          svSyncStatus: null,
          svAuthor: '',
          svLikeCount: 0,
          svCollectCount: 0,
          svCommentCount: 0,
          ageGroup: null,
          nickname: ''
        }
      },
      platformText (platform) {
        let map = { douyin: '抖音', xhs: '小红书', channels: '视频号' }
        return map[platform] || platform
      },
      mediaUrl (url) {
        if (!url) {
          return ''
        }
        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
          return url
        }
        return 'http://medias.kouyujie.cn/' + url
      },
      taskStatusText (status) {
        let map = { pending: '待抓取', running: '抓取中', success: '成功', fail: '失败' }
        return map[status] || '-'
      },
      loadTasks (id) {
        let self = this
        self.$http.get('/userVideo/shortVideo/tasks?id=' + id).then(function (res) {
          if (self.userVideoParams.id !== id) {
            return
          }
          self.svTasks = Array.isArray(res.data) ? res.data : []
        })
      },
      svUrlError () {
        let p = this.userVideoParams
        let hostIn = function (host, domain) {
          return host === domain || host.slice(-domain.length - 1) === '.' + domain
        }
        let rules = [
          { key: 'douyinUrl', name: '抖音', ok: (host) => ['douyin.com', 'v.douyin.com', 'iesdouyin.com'].some(d => hostIn(host, d)) },
          { key: 'xhsUrl', name: '小红书', ok: (host) => ['xiaohongshu.com', 'xhslink.com', 'xhslink.cn'].some(d => hostIn(host, d)) },
          { key: 'channelsUrl', name: '视频号', ok: (host, path) => hostIn(host, 'channels.weixin.qq.com') || (hostIn(host, 'weixin.qq.com') && path.indexOf('sph') >= 0) }
        ]
        for (let i = 0; i < rules.length; i++) {
          let r = rules[i]
          let text = (p[r.key] || '').trim()
          if (!text) continue
          if (text.length > 1024) return r.name + '链接过长'
          let m = /https?:\/\/([^/?#\s:]+)(?::\d+)?([^?#\s]*)/i.exec(text)
          if (!m || !r.ok(m[1].toLowerCase(), m[2] || '')) return r.name + '链接不是' + r.name + '地址'
        }
        return ''
      },
      fileItem (key) {
        if (!key) {
          return []
        }
        let name = String(key).split('/').pop()
        return [{ name: name, url: 'http://medias.kouyujie.cn/' + key, status: 'success', uid: name }]
      },
      videoChange (file, fileList) {
        if (file && file.raw) {
          this.videoFileList = fileList.slice(-1)
        }
      },
      videoSuccess (res, file, fileList) {
        this.$Message.destroy()
        if (!res || !res.data) {
          this.$Message.error((res && res.msg) || '上传失败')
          return
        }
        this.userVideoParams.videoUrl = res.data.name
        this.videoUrl = res.data.url
        this.localVideoDirty = true
        this.videoFileList = this.fileItem(res.data.name)
      },
      videoExceed (files) {
        if (!this.formReady || !files || !files[0]) {
          return
        }
        this.videoFileList = []
        this.$nextTick(() => {
          let up = this.$refs.videoUpload
          if (!up) return
          up.handleStart(files[0])
          up.submit()
        })
      },
      videoPicChange (file, fileList) {
        if (file && file.raw) {
          this.videoPicFileList = fileList.slice(-1)
        }
      },
      videoPicSuccess (res, file, fileList) {
        this.$Message.destroy()
        if (!res || !res.data) {
          this.$Message.error((res && res.msg) || '上传失败')
          return
        }
        this.userVideoParams.videoPicUrl = res.data.name
        this.videoPicUrl = res.data.url
        this.localPicDirty = true
        this.videoPicFileList = this.fileItem(res.data.name)
      },
      videoPicExceed (files) {
        if (!this.formReady || !files || !files[0]) {
          return
        }
        this.videoPicFileList = []
        this.$nextTick(() => {
          let up = this.$refs.videoPicUpload
          if (!up) return
          up.handleStart(files[0])
          up.submit()
        })
      },
      beforeUpload (file) {
        if (!this.formReady) {
          return false
        }
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      handleUploadError () {
        this.$Message.destroy()
        this.$Message.error('上传失败')
      },
      handleProgress (event, file, fileList) {
        if (event.percent === 100) {
          event.percent = 99
        }
      },
      fetchShortVideo (platform) {
        let self = this
        if (self.loadingFetch) {
          return
        }
        if (!self.userVideoParams.id) {
          self.$Message.warning('作品ID无效')
          return
        }
        let p = self.userVideoParams
        if (platform) {
          if (!(p[platform + 'Url'] || '').trim()) {
            self.$Message.warning('请先填写' + self.platformText(platform) + '链接')
            return
          }
        } else if (!((p.douyinUrl || '') + (p.xhsUrl || '') + (p.channelsUrl || '')).trim()) {
          self.$Message.warning('请先填写短视频链接')
          return
        }
        let urlError = self.svUrlError()
        if (urlError) {
          self.$Message.warning(urlError)
          return
        }
        let id = p.id
        self.loadingFetch = true
        // 先保存链接再抓取
        self.$http.post('/userVideo/update', {
          id: id,
          douyinUrl: p.douyinUrl || '',
          xhsUrl: p.xhsUrl || '',
          channelsUrl: p.channelsUrl || ''
        }).then(function (res) {
          if (res.status !== 'ok') return res
          let fetchParams = { id: id }
          if (platform) fetchParams.platform = platform
          return self.$http.post('/userVideo/shortVideo/fetch', fetchParams)
        }).then(function (res) {
          self.loadingFetch = false
          if (res.status !== 'ok') return
          self.$Message.success((res.data && res.data.message) ? res.data.message : '已提交')
          self.loadTasks(id)
          if (self.successCallback) self.successCallback()
        }).catch(function () {
          self.loadingFetch = false
        })
      },
      editUserVideo () {
        let self = this
        self.loadingEditModal = true
        self.$refs.userVideoForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingEditModal = false
            return
          }
          let urlError = self.svUrlError()
          if (urlError) {
            self.$Message.warning(urlError)
            self.loadingEditModal = false
            return
          }
          let p = self.userVideoParams
          self.$http.post('/userVideo/update', {
            id: p.id,
            uid: p.uid,
            title: p.title,
            ageGroup: p.ageGroup,
            videoUrl: p.videoUrl,
            videoPicUrl: p.videoPicUrl,
            douyinUrl: p.douyinUrl || '',
            xhsUrl: p.xhsUrl || '',
            channelsUrl: p.channelsUrl || ''
          }).then(function (res) {
            if (res && res.data > 0) {
              self.visible = false
              self.$Message.success('提交成功!')
              self.successCallback()
              self.loadingEditModal = false
            } else {
              self.$Message.error(res.msg)
              self.loadingEditModal = false
            }
          }).catch(function (e) {
            self.visible = false
            self.loadingEditModal = false
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this._editRequestId = null
          this.userVideoParams = this.blankParams()
          this.svTasks = []
          this.videoFileList = []
          this.videoPicFileList = []
          this.formReady = false
          this.localVideoDirty = false
          this.localPicDirty = false
          this.$Message.destroy()
          this.$emit('on-close', false)
        }
      },
      itemId (val) {
        if (val) {
          let self = this
          let requestId = val
          self._editRequestId = requestId
          self.formReady = false
          self.localVideoDirty = false
          self.localPicDirty = false
          self.$http.get('/userVideo/queryById?id=' + val).then(function (res) {
            if (self._editRequestId !== requestId) {
              return
            }
            if (res.data) {
              let row = res.data
              let keepVideo = self.localVideoDirty ? (self.userVideoParams.videoUrl || '') : (row.videoUrl || '')
              let keepPic = self.localPicDirty ? (self.userVideoParams.videoPicUrl || '') : (row.videoPicUrl || '')
              self.userVideoParams = {
                id: row.id,
                uid: row.uid,
                nickname: row.nickname || '',
                title: row.title || '',
                ageGroup: null,
                videoUrl: keepVideo,
                videoPicUrl: keepPic,
                douyinUrl: row.douyinUrl || '',
                xhsUrl: row.xhsUrl || '',
                channelsUrl: row.channelsUrl || '',
                svSyncStatus: row.svSyncStatus,
                svAuthor: row.svAuthor || '',
                svLikeCount: row.svLikeCount || 0,
                svCollectCount: row.svCollectCount || 0,
                svCommentCount: row.svCommentCount || 0
              }
              self.svTasks = []
              self.loadTasks(row.id)
              if (!self.localVideoDirty) {
                self.videoFileList = self.fileItem(row.videoUrl)
              }
              if (!self.localPicDirty) {
                self.videoPicFileList = self.fileItem(row.videoPicUrl)
              }
              self.$nextTick(function () {
                if (self._editRequestId !== requestId) {
                  return
                }
                self.userVideoParams.ageGroup = row.ageGroup
                self.formReady = true
              })
            } else {
              self.formReady = true
            }
            self.$emit('on-edit-clearid')
          }).catch(function () {
            if (self._editRequestId === requestId) {
              self.formReady = true
            }
            self.$emit('on-edit-clearid')
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EditUserVideoModal.vue?62a0def1